exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control.register-birth.birth-day[data-v-f0b37bbc] {\n  background-image: none;\n}\n.form-control.register-birth.birth-month[data-v-f0b37bbc] {\n  background-image: none;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput[data-v-f0b37bbc]::-webkit-outer-spin-button,\ninput[data-v-f0b37bbc]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-f0b37bbc] {\n  -moz-appearance: textfield;\n}\n.flex-1[data-v-f0b37bbc] {\n  flex: 1;\n}\n.flex-8[data-v-f0b37bbc] {\n  flex: 8;\n}", ""]);

// exports
